import { useEffect, useState } from "react";
import { api } from "../api";
import { Printer, Loader2, Tag, FileDown } from "lucide-react";
import { toast } from "sonner";
import { jsPDF } from "jspdf";

function esc(s) {
  return String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function labelHTML(o) {
  const addr = o.address || {};
  const itemRows = (o.items || []).map((i) => `
    <tr>
      <td class="cell"><div class="lbl">MODELO</div><div class="val">${esc(i.name)} x${i.qty}</div></td>
      <td class="cell"><div class="lbl">COR</div><div class="val">${esc(i.color || "—")}</div></td>
      <td class="cell"><div class="lbl">TAMANHO</div><div class="val">${i.size}</div></td>
    </tr>`).join("");
  return `
  <div class="label">
    <div class="head"><span class="logo">VULT<span class="dot">.</span></span><span class="tag">ETIQUETA DE ENVIO</span></div>
    <div class="box">
      <div class="lbl">DESTINO</div>
      <div class="name">${esc(o.customer_name)}</div>
      <div class="addr">${esc(addr.rua || "")}, ${esc(addr.numero || "")}<br/>${esc(addr.cidade || "")} — ${esc(addr.estado || "")}<br/>CEP: ${esc(addr.cep || "")}</div>
    </div>
    <table class="grid">${itemRows}</table>
    <div class="row">
      <div class="col"><div class="lbl">PEDIDO</div><div class="val">${esc(o.id)}</div></div>
      <div class="col"><div class="lbl">REMETENTE</div><div class="val">VULT OFICIAL<br/>Belo Horizonte — MG</div></div>
    </div>
    <div class="foot">PRAZO ESTIMADO: 20 DIAS ATÉ O DESTINO FINAL</div>
  </div>`;
}

export function printLabels(orders) {
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(`<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"/><title>Etiquetas Vult</title><style>
    @page { size: 10cm 15cm; margin: 0; }
    * { box-sizing: border-box; }
    body { margin: 0; font-family: Arial, sans-serif; }
    .label { width: 10cm; height: 15cm; page-break-after: always; padding: 0.6cm; border: 2px solid #0F172A; display: flex; flex-direction: column; gap: 0.3cm; }
    .head { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #0F172A; padding-bottom: 0.25cm; }
    .logo { font-size: 26px; font-weight: 900; font-style: italic; }
    .dot { color: #FFD600; }
    .tag { font-size: 10px; font-weight: 700; letter-spacing: 2px; }
    .box { border: 2px solid #0F172A; border-radius: 8px; padding: 0.3cm; }
    .lbl { font-size: 8px; font-weight: 700; letter-spacing: 2px; color: #64748B; margin-bottom: 2px; }
    .name { font-size: 16px; font-weight: 900; text-transform: uppercase; }
    .addr { font-size: 11px; margin-top: 2px; }
    .row { display: flex; gap: 0.3cm; }
    .col { flex: 1; border: 1px solid #CBD5E1; border-radius: 8px; padding: 0.2cm; }
    .val { font-size: 10px; font-weight: 700; }
    .grid { width: 100%; border-collapse: collapse; }
    .cell { border: 1px solid #CBD5E1; border-radius: 6px; padding: 0.15cm 0.25cm; }
    .foot { margin-top: auto; background: #FFD600; text-align: center; font-size: 9px; font-weight: 900; letter-spacing: 1px; padding: 0.2cm; border-radius: 6px; }
  </style></head><body>${orders.map(labelHTML).join("")}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 500);
}

function drawLabelPDF(doc, o) {
  const addr = o.address || {};
  doc.setDrawColor(15, 23, 42);
  doc.setLineWidth(0.8);
  doc.rect(3, 3, 94, 144);

  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(24);
  doc.setTextColor(15, 23, 42);
  doc.text("VULT.", 8, 14);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(100, 116, 139);
  doc.text("ETIQUETA DE ENVIO", 92, 12, { align: "right" });
  doc.line(8, 17, 92, 17);

  doc.setLineWidth(0.6);
  doc.roundedRect(8, 21, 84, 26, 2, 2);
  doc.setFontSize(6);
  doc.setTextColor(100, 116, 139);
  doc.text("DESTINO", 11, 27);
  doc.setFontSize(13);
  doc.setTextColor(15, 23, 42);
  doc.setFont("helvetica", "bold");
  doc.text(String(o.customer_name || "").toUpperCase(), 11, 34);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(`${addr.rua || ""}, ${addr.numero || ""}`, 11, 39.5);
  doc.text(`${addr.cidade || ""} - ${addr.estado || ""}   CEP: ${addr.cep || ""}`, 11, 44);

  let y = 51;
  (o.items || []).forEach((i) => {
    doc.setDrawColor(203, 213, 225);
    doc.setLineWidth(0.3);
    doc.roundedRect(8, y, 52, 13, 1.5, 1.5);
    doc.roundedRect(62, y, 16, 13, 1.5, 1.5);
    doc.roundedRect(80, y, 12, 13, 1.5, 1.5);
    doc.setFontSize(5.5);
    doc.setTextColor(100, 116, 139);
    doc.text("MODELO", 11, y + 4);
    doc.text("COR", 65, y + 4);
    doc.text("TAM", 83, y + 4);
    doc.setFontSize(8);
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "bold");
    doc.text(doc.splitTextToSize(`${i.name} x${i.qty}`, 48)[0], 11, y + 9.5);
    doc.text(String(i.color || "—"), 65, y + 9.5);
    doc.text(String(i.size), 83, y + 9.5);
    y += 16;
  });

  doc.roundedRect(8, y, 41, 14, 1.5, 1.5);
  doc.roundedRect(51, y, 41, 14, 1.5, 1.5);
  doc.setFontSize(5.5);
  doc.setTextColor(100, 116, 139);
  doc.text("PEDIDO", 11, y + 4.5);
  doc.text("REMETENTE", 54, y + 4.5);
  doc.setFontSize(8);
  doc.setTextColor(15, 23, 42);
  doc.text(String(o.id), 11, y + 10);
  doc.setFontSize(7);
  doc.text("VULT OFICIAL - Belo Horizonte/MG", 54, y + 10);

  doc.setFillColor(255, 214, 0);
  doc.roundedRect(8, 132, 84, 10, 2, 2, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.5);
  doc.setTextColor(15, 23, 42);
  doc.text("PRAZO ESTIMADO: 20 DIAS ATE O DESTINO FINAL", 50, 138.5, { align: "center" });
}

function downloadLabelsPDF(orders) {
  const doc = new jsPDF({ unit: "mm", format: [100, 150] });
  orders.forEach((o, idx) => {
    if (idx > 0) doc.addPage([100, 150]);
    drawLabelPDF(doc, o);
  });
  doc.save(orders.length === 1 ? `etiqueta-${orders[0].id}.pdf` : "etiquetas-vult.pdf");
}

export function LabelsPanel() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/orders").then(({ data }) => setOrders(data)).catch(console.error).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const printable = orders.filter((o) => ["Pago", "Enviado"].includes(o.status));

  const markShipped = async (list) => {
    const toShip = list.filter((o) => ["Pendente", "Pago"].includes(o.status));
    if (!toShip.length) return;
    try {
      await Promise.all(toShip.map((o) => api.patch(`/orders/${o.id}/status`, { status: "Enviado" })));
      toast.success(`${toShip.length} pedido(s) marcado(s) como Enviado`);
      load();
    } catch (e) {
      toast.error("Falha ao atualizar o status");
    }
  };

  const printAndShip = (list) => { printLabels(list); markShipped(list); };
  const pdfAndShip = (list) => { downloadLabelsPDF(list); markShipped(list); };

  if (loading) return <div className="mt-5 flex justify-center py-10"><Loader2 className="animate-spin text-vult-red" size={28} /></div>;

  return (
    <div data-testid="vult-admin-labels-panel" className="mt-5">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white p-4">
        <div className="flex items-center gap-2 text-sm text-slate-600">
          <Tag size={16} className="text-vult-blue" />
          {printable.length} pedido(s) pronto(s) para etiqueta (Pagos/Enviados)
        </div>
        <div className="flex gap-2">
          <button
            data-testid="vult-admin-labels-pdf-all"
            onClick={() => pdfAndShip(printable)}
            disabled={printable.length === 0}
            className="flex items-center gap-2 rounded-full border-2 border-slate-900 px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-widest transition-colors hover:bg-slate-900 hover:text-white disabled:opacity-40"
          >
            <FileDown size={14} /> Baixar PDF
          </button>
          <button
            data-testid="vult-admin-labels-print-all"
            onClick={() => printAndShip(printable)}
            disabled={printable.length === 0}
            className="flex items-center gap-2 rounded-full bg-vult-red px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-widest text-slate-900 transition-colors hover:bg-slate-900 hover:text-white disabled:opacity-40"
          >
            <Printer size={14} /> Imprimir todas
          </button>
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
        {orders.length === 0 ? (
          <div data-testid="vult-admin-labels-empty" className="py-14 text-center font-display text-xl font-black uppercase text-slate-300">Nenhum pedido ainda</div>
        ) : (
          <ul>
            {orders.map((o) => (
              <li key={o.id} data-testid={`vult-admin-label-row-${o.id}`} className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-4 last:border-0 hover:bg-[#F8F9FA]">
                <div>
                  <div className="font-mono text-sm font-bold text-slate-900">{o.id}</div>
                  <div className="text-xs text-slate-500">
                    {o.customer_name} — {o.address?.cidade || "?"}/{o.address?.estado || "?"} • {o.items?.length || 0} item(ns) • {o.status}
                  </div>
                </div>
                <div className="flex gap-2">
                  <button
                    data-testid={`vult-admin-label-pdf-${o.id}`}
                    onClick={() => pdfAndShip([o])}
                    title="Baixar etiqueta em PDF"
                    className="flex items-center gap-2 rounded-full border-2 border-slate-900 px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-widest transition-colors hover:bg-slate-900 hover:text-white"
                  >
                    <FileDown size={13} /> PDF
                  </button>
                  <button
                    data-testid={`vult-admin-label-print-${o.id}`}
                    onClick={() => printAndShip([o])}
                    className="flex items-center gap-2 rounded-full border-2 border-slate-900 px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-widest transition-colors hover:bg-slate-900 hover:text-white"
                  >
                    <Printer size={13} /> Etiqueta
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
